export default __webpack_public_path__ + "img/alarms-rules.39221fad.png";